module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p'), _vm._v(" "), _c('tabs', {
    attrs: {
      "list": _vm.list,
      "value": _vm.active
    },
    on: {
      "update:value": function($event) {
        _vm.active = $event
      }
    }
  }, [_c('div', {
    slot: "Sales Order"
  }, [_c('section', {
    staticClass: "padding10"
  }, [_c('div', {
    staticClass: "input-control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Category")]), _vm._v(" "), _c('vi-select', {
    attrs: {
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button primary"
  }, [_vm._v("Search")])]), _vm._v(" "), _c('table', {
    staticClass: "table border bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Abby")]), _vm._v(" "), _c('td', [_vm._v("The npm command-line tool is bundled with Node.js")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jasmine")]), _vm._v(" "), _c('td', [_vm._v("Everything you see exists together in a delicate balance")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag alert"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Camille")]), _vm._v(" "), _c('td', [_vm._v("Whatever is worth doing is worth doing well")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag success"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vanessa")]), _vm._v(" "), _c('td', [_vm._v("In love folly is always sweet.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Magical")]), _vm._v(" "), _c('td', [_vm._v("The hard part isn’t making the decision. It’s living with it")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag warning"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Abby")]), _vm._v(" "), _c('td', [_vm._v("The npm command-line tool is bundled with Node.js")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jasmine")]), _vm._v(" "), _c('td', [_vm._v("Everything you see exists together in a delicate balance")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag alert"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Camille")]), _vm._v(" "), _c('td', [_vm._v("Whatever is worth doing is worth doing well")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag success"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "margin10"
  }, [_c('pagination', {
    attrs: {
      "total": 60
    }
  })], 1)]), _vm._v(" "), _c('div', {
    slot: "Purchase Order"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('slide', {
    attrs: {
      "list": _vm.imgList,
      "duration": 5000
    }
  })], 1)]), _vm._v(" "), _c('div', {
    slot: "Products"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dbfad62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demo2.vue
// module id = 391
// module chunks = 1